module.exports = __webpack_public_path__ + "084c9c96b3f72668912c3256fed0b8b7.png";